import React, { Fragment, useState } from "react"
import { Badge, Box, Button, Grid2 as Grid, Popover, Stack, Typography } from "@mui/material";
import { GenericIconButton } from "../../generic/GenericIconButton";
import { Bell, CaretDown, CaretUp, GearSix, SignOut, SquaresFour, UserCircle, UsersFour, ChatTeardropText } from "@phosphor-icons/react";
import { GenericAvatar } from "../../generic/GenericAvatar";
import { SHADOWS } from "../../../enums/themeEnum";
import { GenericDivider } from "../../generic/GenericDivider";
import { router, usePage } from '@inertiajs/react';
import useStore from "../../../states/store";
import { NotificationList } from "../../../pages/creator/creatorHomePage/NotificationList";
import { useLogoutUser } from "../../generic/functions/genericFunctions";
import { ADMIN_ROLE, CREATOR_ROLE, DEVELOPER_ROLE, PENDING_CREATOR_ROLE } from "../../../enums/generalEnums";
import { PAGE_PERMISSIONS } from "../../../enums/permissions/permission";
const { CAN_VIEW_EDIT_PROFILE_PAGE, CAN_VIEW_SETTINGS_PAGE, CAN_VIEW_ALL_CHATS, CAN_VIEW_CHATS_PAGE } = PAGE_PERMISSIONS;

export const ProfileDropDown = ({ user }) => {
  const { auth } = usePage().props;
  const handleLogout = useLogoutUser();
  const [{ notificationsCount, loggedIndUserDetails }, { hasPermission }] = useStore();
  const genericButtonStyle = {
    color: 'text.light',
    justifyContent: 'flex-start',
    textAlign: 'left',
    borderRadius: '10px',
    '&:hover': {
      boxShadow: 'none',
      backgroundColor: 'background.default'
    }
  }
  const [anchorEl, setAnchorEl] = useState(null);
  const [isProfile, setIsProfile] = useState(true);
  const profession = (user?.role === CREATOR_ROLE || user?.role === PENDING_CREATOR_ROLE) ? loggedIndUserDetails?.profession : user?.role;

  const handleOpenDropDown = (event, type = true) => {
    setAnchorEl(event.currentTarget);
    setIsProfile(type);
  };

  const handleVisitOverview = () => {
    if (user?.role === PENDING_CREATOR_ROLE) {
      router.visit('/edit-profile');
    } else {
      router.visit(user?.role === CREATOR_ROLE ? '/overview' : '/admin');
    }
    setAnchorEl(null);
  };

  const dropDownButtons = [
    {
      icon: <SquaresFour size={16} weight="bold" />,
      label: 'Dashboard',
      action: () => handleVisitOverview(),
      visible: true
    },
    {
      icon: <UserCircle size={16} weight="bold" />,
      label: 'Profile',
      action: () => router.visit('/edit-profile'),
      visible: hasPermission(CAN_VIEW_EDIT_PROFILE_PAGE)
    },
    {
      icon: <UsersFour size={16} weight="bold" />,
      action: () => router.visit('/collab-creators'),
      label: 'Collab Creators',
      visible: auth?.user?.role === CREATOR_ROLE
    },
    {
      icon: <GearSix size={16} weight="bold" />,
      label: 'Settings',
      visible: hasPermission(CAN_VIEW_SETTINGS_PAGE),
      action: () => router.visit('/settings'),
    }
  ]

  return (
    <Fragment>
      <Stack direction={'row'} gap={2} mb={{ xs: 0.7, sm: 0 }}>
        {
          user?.role !== PENDING_CREATOR_ROLE && <Badge
            color="error"
            overlap="circular"
            badgeContent={notificationsCount}
            sx={{
              '.MuiBadge-badge': {
                border: '2px solid #FFF',
                width: '20px',
                height: '20px',
                color: '#FFF',
                borderRadius: '100%',
                mt: '5px',
                mr: '2px',
                fontSize: '10px',
                fontWeight: 700
              }
            }}
          >
            {
              (hasPermission(CAN_VIEW_ALL_CHATS) || hasPermission(CAN_VIEW_CHATS_PAGE)) && <GenericIconButton
                tooltip={'View Chats'}
                onClick={() => { (auth?.user?.role === ADMIN_ROLE || auth?.user?.role === DEVELOPER_ROLE) ? router.visit('/admin-chats') : router.visit('/chats'); }}
                icon={<ChatTeardropText color={'#FFF'} size={24} weight="bold" />}
              />
            }
            <GenericIconButton
              onClick={(event) => handleOpenDropDown(event, false)}
              icon={<Bell color={'#FFF'} size={24} weight="bold" />}
            />
          </Badge>
        }
        <Box sx={{ display: { sm: 'none' } }} onClick={(event) => handleOpenDropDown(event)}>
          <GenericAvatar location={user?.profile_picture_location} backgroundColor={'grey.light'} />
        </Box>
        <Grid container sx={{ color: '#FFF', cursor: 'pointer', display: { xs: 'none', sm: 'flex' } }} spacing={1} alignItems={'center'} onClick={handleOpenDropDown}>
          <Grid item>
            <GenericAvatar location={user?.profile_picture_location} backgroundColor={'grey.light'} />
          </Grid>
          <Grid item>
            <Typography fontWeight={700} sx={{ textTransform: 'capitalize' }}>{user?.name}</Typography>
            <Typography variant="body2" textTransform={'capitalize'}>{profession}</Typography>
          </Grid>
          <Grid item ml={2}>
            {(anchorEl && isProfile) ? <CaretUp size={16} weight="bold" /> : <CaretDown size={16} weight="bold" />}
          </Grid>
        </Grid>
      </Stack>
      <Popover
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        sx={{
          '.MuiPaper-root': {
            boxShadow: SHADOWS.light,
            padding: '16px',
            borderRadius: '15px',
            marginTop: '8px',
            width: isProfile ? '250px' : '350px'
          }
        }}
      >
        {
          isProfile ? <Fragment>
            <Grid container spacing={1} alignItems={'center'} sx={{ cursor: 'pointer' }} onClick={() => handleVisitOverview()}>
              <Grid item>
                <Stack direction={'row'} gap={0.5} >
                  <GenericAvatar location={user?.profile_picture_location} />
                </Stack>
              </Grid>
              <Grid item>
                <Typography fontWeight={700} sx={{ textTransform: 'capitalize' }}>{user?.name}</Typography>
                <Typography variant="body2" color="text.light" textTransform={'capitalize'}>{profession}</Typography>
              </Grid>
            </Grid>
            <GenericDivider />
            <Stack gap={1}>
              {
                dropDownButtons?.map((item, index) => {
                  return (
                    <Fragment key={`button-key-${index}`}>
                      {
                        item?.visible && <Button

                          fullWidth
                          startIcon={item?.icon}
                          sx={{ ...genericButtonStyle }}
                          onClick={() => { item?.action(); setAnchorEl(null) }}
                        >
                          {item?.label}
                        </Button>
                      }
                    </Fragment>
                  )
                })
              }
            </Stack>
            <GenericDivider />
            <Button
              fullWidth
              startIcon={<SignOut size={16} weight="bold" />}
              sx={{ ...genericButtonStyle }}
              onClick={() => handleLogout()}
            >
              Log Out
            </Button>
          </Fragment> : <NotificationList isTopBar={true} userId={user?.user_id} />
        }
      </Popover>
    </Fragment >
  )
}